import { render } from "./convenios.vue?vue&type=template&id=4eb1f97a"
import script from "./convenios.vue?vue&type=script&lang=js"
export * from "./convenios.vue?vue&type=script&lang=js"

import "./convenios.vue?vue&type=style&index=0&id=4eb1f97a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__